module.exports = __webpack_public_path__ + "static/media/promo-rasasport.229e4ae8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-rasasport.jpg
// module id = 318
// module chunks = 0